import React from 'react'
import '../styles/layout/About.css'
import { Container } from 'react-bootstrap';

const OFFERINGS = [
  {
    title: 'Card Programs built for Everyone',
    body: 'Limit assignment based on customer risk assessment & credit profiles including secured cards.',
  },
  {
    title: 'Cards that can be used Everywhere.',
    body: 'Through POS machines, UPI, E-Commerce websites.',
  },
  {
    title: 'A Card for Everything',
    body: 'Enable customer purchases, both large and small.',
  },
  {
    title: 'Customised Card Configurations',
    body: 'Restrict usage based on merchant codes, location, amount limits etc.',
  },
  {
    title: 'End-to-End Support',
    body: 'We undertake the complete customer life cycle management right from KYC checks, onboarding, risk profiling, fraud control, billing and collections.',
  },
  {
    title: 'Rewards Program Management',
    body: 'We will manage the entire cards reward and customer loyalty programs for you.',
  },
]

const AboutusWeOffer = () => {
  return (
    <section className="we-offer section section--defer section--soft section--divide">
      <span className="aurora aurora--violet aurora--low" aria-hidden="true" />
      <span className="section__photo section__photo--offer" data-parallax aria-hidden="true" />
      <Container>
        <div className="we-offer-title reveal">
          <h1>We Offer</h1>
          <span className="rule" />
        </div>
        <div className="we-offer-body">
          {OFFERINGS.map(({ title, body }, i) => (
            <article className="card-x reveal" key={title} data-delay={(i % 3) + 1}>
              <h3>{title}</h3>
              <h4>{body}</h4>
            </article>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default AboutusWeOffer
